import React from "react";
import "./NoPostMsg.css";
import { IoLayers } from "react-icons/io5";

interface NoPostMsgProps {
  message: string;
  className?: string;
  children?: React.ReactNode;
}

const NoPostMsg: React.FC<NoPostMsgProps> = ({
  message,
  className = "",
  children,
}) => (
  <div
    className={`no-content-empty-state ${className}`}
  >
    <div className="no-content-icon-container">
    <IoLayers style={{ fontSize: "2rem",color:"#d1d5db" }} />

    </div>
    <p className="no-content-message">{message}</p>
    {children}
  </div>
);

export default NoPostMsg;
